import { DETAIL_MOVIE, FETCH_MOVIE, MOVIE_GENRE } from "../actions/actiontype"
const initialState= {movies: [],detailMovies:[],genre:[]}

function movieReducer(state= initialState, action){
    switch(action.type){
        case FETCH_MOVIE:
            return{...state,movies: action.payload}
        case DETAIL_MOVIE:
            return{...state,detailMovies: action.payload}
        case MOVIE_GENRE:
            return{...state,genre: action.payload}
        default:
            return state
    }
}

export default movieReducer